import React, { useState, useEffect } from "react";
import Select from "react-select";
import Chart from "react-apexcharts";
import { object } from "prop-types";



const DashboardTransportista = (props) => {



  
  //Estatus, Plataformas, localidades, Transportistas, Clientes, Pais
  const [otdList, setOtdList] = useState([]);
  const [limpiar,setLimpiar] = useState(false);
  const [otdListFiltrados, setotdListFiltrados] = useState([]);
  const [movsSinFiltrar, setmovsSinFiltrar] = useState(props.lista);
  const [otdEstatusOpciones, setOtdEstatusOpciones]= useState([]);
  const [otdEstatusOpcion, setOtdEstatusOpcion] = useState();
  const [localidadesOpciones, setlocalidadesOpciones]= useState([]);
  const [localidadesOpcion, setlocalidadesOpcion] = useState();
  const [usaCorredor, setUsaCorredor] = useState(false);
  const [arrayFilters,setArrayFilters] = useState([{}]);
  //Carga de pantalla de carga
  const [isloading, setisLoading] = useState(true);
  
  // Obtiene  mes, y dia  del año actual
  let dateNow = new Date();

  const month = dateNow.toLocaleString("default", { month: "2-digit" });

  let startDate = `${dateNow.getFullYear()}-${month}-01`;
  
  const year = dateNow.toLocaleString("default", { year: "numeric" });
 
  const day = dateNow.toLocaleString("default", { day: "2-digit" });

  // Genera yyyy-mm-dd date string
  const endDate = year + "-" + month + "-" + day;

  var user = JSON.parse(sessionStorage.getItem("usuario"));

  useEffect(() => {

         
                if(isloading){
               
                  setmovsSinFiltrar(props.lista)
                }

                if(props.eliminaFiltros){

                  let eventRemove = {action:"remove-value" ,removedValue:"", name:"estatus"}  
                  eventRemove.removedValue = {value:""}; 

                  if(props.lista[0].movimientosPatios.length > 0){
                    eventRemove.removedValue.value = "Sin asignacion";
                  }
                  else if(props.lista[0].movimientosPatios.length == 0){
                    eventRemove.removedValue.value= "Asignados"
                  } 


                setOtdEstatusOpcion(null)
                setlocalidadesOpcion(null)
 
               }

              // if(props.lista.length > 0) {
               
                let movsCambiados = props.lista ;

                if(props.cambioPlataforma ){

                  movsCambiados =  props.sinFiltrar;

                  if(props.plataforma != 0){
                          movsCambiados = movsCambiados.filter((mov) => mov.idPlataforma.id == props.plataforma);
                  }
                  
                  setmovsSinFiltrar(movsCambiados);
               // }


                movsCambiados.forEach((movs) => {
               
                  if( props.lista.length > 0 && movs.id == props.lista[0].idMovimiento){
                   
                    movs.movimientosPatios = props.lista[0].movimientosPatios
                  }
                })

               setOtdList(movsCambiados);
               filtroDeFiltros(movsCambiados);
               filtro(movsCambiados);
               setisLoading(false)  
               props.refresca(false)
               }
               
                
  }, [otdEstatusOpcion,localidadesOpcion,props.cambioPlataforma,props.banderaRefresca,limpiar]);



  //Definición de la función de consulta
  
  const filtroDeFiltros=(dataOtdLisTemp)=>{



    let otdTemp= dataOtdLisTemp? [...dataOtdLisTemp]: [...otdList];
    let otdEstatus = {};
    let localidades = {};
    
    otdTemp.map((otd, index) => {

      if(otd.idCorredor && !otd.idLocalidad) setUsaCorredor(true);


      let banderaCamposVacios = otd?.movimientosPatios?.[0]?.economicor != "" && otd?.movimientosPatios?.[0]?.remolquePlaca != "" ?  false:true;

        if(otd?.movimientosPatios?.length > 0 && otd?.movimientoGps.length > 0){
          // if(!props.transportista){
            otd.idOperacionEstatus.nombre= "Colocados";
         // }
       
        }else if(otd?.movimientosPatios?.length > 0 && !banderaCamposVacios){
             otd.idOperacionEstatus.nombre = "Asignados";
        }
        else if(!otd?.movimientosPatios || otd.movimientosPatios?.length == 0 || banderaCamposVacios){
          otd.idOperacionEstatus.nombre = "Sin asignacion"
        }     
      if (!otdEstatus[otd.idOperacionEstatus.nombre]) otdEstatus[otd.idOperacionEstatus.nombre] = [];
   
      otdEstatus[otd.idOperacionEstatus.nombre].push(otd);

      // corredor
      const localidadNombre = otd.idLocalidad?.nombre || otd.idCorredor?.nombre || 'Sin localidad';
      if (!localidades[localidadNombre]) localidades[localidadNombre] = [];
      localidades[localidadNombre].push(otd);

    });



    //creando headers
    let otdEstatusOpcionesTemp = [];
    let localidadesOpcionesTemp = [];
 

    Object.keys(otdEstatus)         .forEach((key) => otdEstatusOpcionesTemp.push({ value: key, label: key}));
    Object.keys(localidades)         .forEach((key) => localidadesOpcionesTemp.push({ value: key, label: key}));
  

    setOtdEstatusOpciones(otdEstatusOpcionesTemp);
    setlocalidadesOpciones(localidadesOpcionesTemp);
 
  }

const handleChangeOptions = (event=null,data=null ,bandera= false)=>{


    let arrayFiltersTemp ;
    let selectOption;

  
    if((event&& event.action === "select-option")){
      selectOption = event.name;
      if(arrayFilters && arrayFilters.length > 0){
      arrayFiltersTemp = [...arrayFilters,{"name": selectOption,"value": event.option.value}];
      }
    }

    if((event && event.action === "remove-value")){
      
      
      arrayFiltersTemp = arrayFilters;

      if(arrayFilters && arrayFilters.length > 0){
        let index = arrayFilters.findIndex((item)=> item.value === event.removedValue.value)
     
      if(index > 0)arrayFiltersTemp.splice(index, 1);
      }
      

    }


    if(!arrayFiltersTemp && !bandera){
      arrayFiltersTemp = [...arrayFilters]
    }

 
    let otdTemp  = data ? data: [...movsSinFiltrar];



    arrayFiltersTemp.forEach((filter)=>{
    
      {switch(filter.name){
      
       
        case "estatus":{
            let otdTemp3 = otdTemp.filter((o)=> {
              let flag = false;
              arrayFiltersTemp.map((opcion)=>{
                if(opcion.value === o.idOperacionEstatus.nombre ){
                  flag = true;
                  return;
                } 
              });
            return flag;
            });
            otdTemp = otdTemp3;
         
          break;
        }
          
        case "localidades":{
         
          let otdTemp3 = otdTemp.filter((o)=> {
            let flag = false;
            arrayFiltersTemp.map((opcion)=>{
              if(opcion.value === (o.idLocalidad?.nombre || o.idCorredor?.nombre || 'Sin localidad') ){
                flag = true;
                return;
              } 
            });
          return flag;
          });

          otdTemp = otdTemp3;
          break;
        }

      }
    }

    })

    

  if(otdTemp.length == 0  ){
   
    
  }
    

 
    setArrayFilters(arrayFiltersTemp)
    setotdListFiltrados(otdTemp)
    props.filtrados(otdTemp);

}

  const filtro=(dataOtdLisTemp)=>{

  
    let otdTemp= dataOtdLisTemp? [...dataOtdLisTemp]: [...movsSinFiltrar];

    if(arrayFilters && arrayFilters.length > 1){

      handleChangeOptions(null,dataOtdLisTemp);
      return;
    }

    setotdListFiltrados(otdTemp);
    //return otdTemp;
  }


  const random_rgba = (opacidad = 1) => {
    var o = Math.round, r = Math.random, s = 255;
    //return 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ','+opacidad+ ')';
    return 'rgba(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ',' + opacidad + ')';
  }
  const getGraficaOtdEstatus = () => {
    let otdTemp= [...otdListFiltrados];
    let labels = [];
    let data = [];
    let backgroundColor = [];
    let hoverBackgroundColor = [];//["dias"][g.dias]
    for( let gEstatus of otdEstatusOpciones ){
      labels.push(gEstatus.label);
      data.push(otdTemp.filter( g => g.idOperacionEstatus.nombre === gEstatus.label).length);
      backgroundColor.push(random_rgba(0.5));
      hoverBackgroundColor.push(random_rgba());
    }
    return { labels, data };
  }
 
  const getGraficalocalidades = () => {
    let otdTemp= [...otdListFiltrados];
    let labels = [];
    let data = [];
    let backgroundColor = [];
    let hoverBackgroundColor = [];//["dias"][g.dias]
    for( let p of localidadesOpciones ){
      labels.push(p.label);
      data.push(otdTemp.filter( g => (g.idLocalidad?.nombre || g.idCorredor?.nombre || 'Sin localidad') === p.label).length);
      backgroundColor.push(random_rgba(0.5));
      hoverBackgroundColor.push(random_rgba());
    }
    return { labels, data };
  }
 
  
  const reset =()=>{
    setOtdEstatusOpcion([]);
    setlocalidadesOpcion([]);
    setArrayFilters([])
  }

  return (
    <div className="container-fluit">
      <div className="row justify-content-center" style={{ margin: "16px" }}>
        <h1> </h1>
      </div>
      <div className="row row--filters" >
        <div class="col-12">
          <div className="filter--form col-12">
            <div className="col-12 justify-content-start">
              <div className="form-group">
                <label for="estatus">Estatus</label>
                <Select name="estatus" isMulti value={otdEstatusOpcion} onChange={(e,a)=>{ setOtdEstatusOpcion(e); handleChangeOptions(a); }} options={otdEstatusOpciones} />
              </div>
            </div>
            <div className="col-12 justify-content-start">
              <div className="form-group">
                <label htmlFor="estatus">{usaCorredor ? 'Corredor' : 'Localidad'}</label>
                <Select isMulti name="localidades" value={localidadesOpcion} onChange={(e,a)=>{ setlocalidadesOpcion(e); handleChangeOptions(a); }} options={localidadesOpciones} />
              </div>
            </div>
          
            {/* <div className="col-12 justify-content-start">
              <div className="form-group">
                <label for="reset">Restablecer valores</label>
                <button onClick={()=> reset()}  className="btn-primary btn d-block"><i class="fe fe-refresh-ccw"></i></button>
              </div>
            </div> */}

            

          </div>
        
         </div>
    <div className="col-md-12">
    <span>
  <h3 className="text-center">Servicios { otdListFiltrados ? otdListFiltrados.length: 0}</h3>
</span>
                 
      {otdListFiltrados && otdListFiltrados.length > 0 &&

<div>
        <div className="row flex-graficas">
          
          <div className="grafica">
            <div className="card border-primary mb-3">
              <div className="card-header" style={{ backgroundColor: "rgba(57, 121, 249, 0.30)" }}>
                <h4>
                  Estatus
                </h4>
              </div>
              <div className="card-body text-success">
                { otdList.length ?
                  <Chart
                    series= {getGraficaOtdEstatus().data}
                  options= {{
                    chart: {
                      width: 2000,
                      type: 'donut',
                      animations:{
                        enabled:false
                      },
                    },
                    labels:getGraficaOtdEstatus().labels,
                    plotOptions: {
                      pie: {
                        startAngle: -90,
                        endAngle: 270
                      }
                    },  
                    animations:{
                      enabled:true
                    },            
                    dataLabels: {
                      enabled: true
                    },
                    fill: {
                      type: 'gradient',
                    },
                    legend: {
                      formatter: function(val, opts) {
                        return getGraficaOtdEstatus().labels[opts.seriesIndex]+" - "+ opts.w.globals.seriesTotals[opts.seriesIndex]
                      }
                    },
                    title: {
                      text: 'Estatus actual'
                    }
                  }}
                    type="donut" width={"100%"} height={"100%"} />
                :null}
              </div>
            </div>
          </div>
          <div className="grafica otd-heigth">
            <div className="card border-primary mb-3">
              <div className="card-header" style={{ backgroundColor: "rgba(57, 121, 249, 0.30)" }}>
                <h4>
                {usaCorredor ? 'Corredores' : 'Localidades'}
                </h4>
              </div>
              <div className="card-body text-success">
                { otdList.length ?
                <Chart
                  options={{
                    chart: {

                      id: 'apexchart-example',
                      events: {
                        click: function (event, chartContext, config) {
                          //alert(config.labels[config.dataPointIndex]);
                        }
                      },
                      animations:{
                        enabled:false
                      }
                    },
                    xaxis: {
                      categories: getGraficalocalidades().labels,
                    },
                    //colors:["#F44336", "#E91E63", "#9C27B0"]               
                  }}
                  series={
                    [
                      { name: "servicios", data: getGraficalocalidades().data },
                    ]
                  }
                  type="bar"
                  width={"100%"}
                  height={"100%"}
                />
                :null}
              </div>
            </div>
          </div>
          </div>
        </div>
      }
         </div>        
        </div>

     
      <hr />
 
    </div>

    
  );
};

export default DashboardTransportista;